import { Component, Input, ViewChild } from '@angular/core'
import { InstrumentAndPlanHelper } from '../instrument-and-plan-helper'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { expandCollapse, openClose } from '../../animations/open-close-animations'
import { NgTemplateOutlet, CurrencyPipe } from '@angular/common'
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { CdkTableModule } from '@angular/cdk/table'

@Component({
    animations: [
        openClose,
        expandCollapse,
    ],
    selector: 'plan-treatment-unclassified',
    templateUrl: './plan-treatment-unclassified.html',
    imports: [
        CdkTableModule,
        NgxBootstrapIconsModule,
        NgTemplateOutlet,
        CurrencyPipe,
    ]
})
export class PlanTreatmentsUnclassifiedComponent extends InstrumentAndPlanHelper {

    @Input() plan_classes_unclassifieds: any
    @Input() situationID: string = ''
    @Input() colsDefn: string = "col-lg-12 col-xl-6"
    @Input() showMatches: boolean = false

    public isExpanded : Dictionary<boolean> = {}

}